import i18n from '@/i18n'
import { lineService } from '@/services/line.service'
import { mapActions } from 'vuex'
import { SnackbarStyle, REGEX, LINE_ACTIVE_STATE, EventHub } from '@/constants/constants'
import { DialogLINE } from "@/tools/dialog"
import LineDialogDataTabComponent from './tabs/data/LineDialogDataTabComponent.vue'
import LineDialogCommentTabComponent from './tabs/comment/LineDialogCommentTabComponent.vue'
import Vue from 'vue'

export default {
    name: 'LineDialogComponent',
    components: {
        LineDialogDataTabComponent,
        LineDialogCommentTabComponent
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // tab seleccionada
        tab: null,
        // modelos de los tabs
        items: [
            {
                key: 'lineDialogDataTab',
                tab: i18n.t('data'),
                tooltip: i18n.t('line.editDialog.tabs.data'),
                icon: 'mdi-form-textbox',
                content: {
                    _uid: 'eMRaQyqSGG',
                    component: 'LineDialogDataTabComponent',
                    headline: 'LineDialogDataTabComponent'
                },
                model: {
                    lineNumber: null,
                    carrier: null,
                    stateId: null,
                    simCard: null,
                    roaming: false,
                    update: false
                },
                validForm: false
            },
            {
                key: 'lineDialogCommentTab',
                tab: i18n.t('line.editDialog.comment'),
                tooltip: i18n.t('line.editDialog.comment'),
                icon: 'mdi-form-textarea',
                content: {
                    _uid: 'bZfZwBGifl',
                    component: 'LineDialogCommentTabComponent',
                    headline: 'LineDialogCommentTabComponent'
                },
                model: {
                    description: null,
                    update: false
                },
                validForm: false
            }
        ],
        // reglas de validación
        validationRules: {
            required: (value) => !!value || `${i18n.t('required')}`,
            maxLength: (value, maxValue) => value && (value.length <= maxValue) || `${i18n.t('maxNumber', {max: maxValue})}`,
            number: (value) => !value || REGEX.number.test(value) || `${i18n.t('onlyNumber')}`,
        },
        // flag para resetear validaciones en los formularios
        resetForms: false
    }),
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            this.items[0].model.lineNumber = null
            this.items[0].model.stateId = LINE_ACTIVE_STATE
            this.items[0].model.carrier = null
            this.items[0].model.simCard = null
            this.items[0].model.roaming = false
            this.items[1].model.description = null
            this.items[0].model.update = false
            this.items[1].model.update = false
            // para limpiar las validaciones en los formularios
            this.resetForms = true
            const that = this
            Vue.nextTick(function() {
                that.resetForms = false
            })
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogLINE)
            this.resetFields()
        },
        /**
         * Guardar
         */
        save() {
            const lineDto = this.getLineDto(this.model.update)
            if (this.model.update) {
                lineService.update(lineDto).then(() => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('line.successUpdateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.resetFields()
                    this.$emit('commitLine')
                    this.cancel()
                    this.$eventBus.$emit(EventHub.COMMIT_LINE, lineDto)
                })
            } else {
                lineService.create(lineDto).then(insertedId => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('line.successCreateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.resetFields()
                    this.$emit('commitLine')
                    this.cancel()
                    lineDto._id = insertedId
                    this.$eventBus.$emit(EventHub.COMMIT_LINE, lineDto)
                })
            }
        },
        /**
         * Genera el DTO para actualizar / crear una línea
         * @param {*} update
         */
        getLineDto(update = false) {
            const result = {
                lineNumber: this.items[0].model.lineNumber,
                carrier: this.items[0].model.carrier,
                simCard: this.items[0].model.simCard,
                stateId: this.items[0].model.stateId,
                roaming: this.items[0].model.roaming,
                description: this.items[1].model.description,
            }
            if (update) {
                result._id = this.model._id
            }
            return result
        }
    },
    watch: {
        model: {
            deep: true,
            immediate: true,
            handler: function (newModel) {
                if (newModel) {
                    this.items[0].model.lineNumber = newModel.lineNumber
                    this.items[0].model.stateId = newModel.stateId
                    this.items[0].model.carrier = newModel.carrier
                    this.items[0].model.simCard = newModel.simCard
                    this.items[0].model.roaming = newModel.roaming
                    this.items[1].model.description = newModel.description
                    this.items[0].model.update = newModel.update
                    this.items[1].model.update = newModel.update
                }
            }
        }
    }
}
